import gql from "graphql-tag";

export const PAYMENTS_DUE_FOR_COLLECTION_ON_A_DAY = gql`
    query PAYMENTS_DUE_FOR_COLLECTION_ON_A_DAY($page: Int!, $perPage: Int!, $paymentDates: [Date]){
        paymentsDueForCollectionReport (page: $page, perPage: $perPage, paymentDates: $paymentDates) {
            page,
            pages,
            total,
            nextPage,
            previousPage,
            hasNext,
            hasPrevious,
            objects {
                invoiceId,
                customer {
                    name
                },
                createdAt
                deliveryDate,
                lpo,
                grossOrderTotal,
                status {
                    publicId,
                    orderStatusName
                }
            }
        }
    }
`;

export const PAYMENTS_COLLECTED_ON_A_DAY = gql`
    query PAYMENTS_COLLECTED_ON_A_DAY($page: Int!, $perPage: Int!, $paymentDates: [Date]){
        paymentsCollectedReport (page: $page, perPage: $perPage, paymentDates: $paymentDates) {
            page,
            pages,
            total,
            nextPage,
            previousPage,
            hasNext,
            hasPrevious,
            objects {
                order {
                    invoiceId,
                    customer {
                        publicId,
                        name
                    },
                    createdAt
                    deliveryDate,
                    lpo,
                    grossOrderTotal
                    status {
                        publicId,
                        orderStatusName
                    }
                }
                paymentRef,
                paymentType {
                    publicId,
                    paymentMethodName
                }
            }
        }
    }
`;

export const ORDERS_DUE_FOR_COLLECTION_ON_A_DAY = gql`
    query PAYMENTS_DUE_FOR_COLLECTION_ON_A_DAY($page: Int!, $perPage: Int!, $collectionDates: [Date], $warehouses: [String]){
        ordersForCollectionReport (page: $page, perPage: $perPage, collectionDates: $collectionDates, warehouses: $warehouses) {
            page,
            pages,
            total,
            nextPage,
            previousPage,
            hasNext,
            hasPrevious,
            objects {
                invoiceId,
                publicId
                customer {
                    name
                },
                createdAt
                deliveryDate,
                lpo,
                grossOrderTotal,
                status {
                    publicId,
                    orderStatusName
                }
                availableStatusChanges{
                    publicId
                    orderStatusName
                }
            }
        }
    }
`;

export const ORDERS_DUE_FOR_DELIVERY_ON_A_DAY = gql`
    query ORDERS_DUE_FOR_DELIVERY_ON_A_DAY($page: Int!, $perPage: Int!, $deliveryDates: [Date], $warehouses: [String]){
        ordersForDeliveryReport (page: $page, perPage: $perPage, deliveryDates: $deliveryDates, warehouses: $warehouses) {
            page,
            pages,
            total,
            nextPage,
            previousPage,
            hasNext,
            hasPrevious,
            objects {
                invoiceId,
                publicId
                customer {
                    name
                },
                createdAt
                deliveryDate,
                lpo,
                grossOrderTotal,
                status {
                    publicId,
                    orderStatusName
                }
                availableStatusChanges{
                    publicId
                    orderStatusName
                }
            }
        }
    }
`;

export const SAMPLE_ORDERS_DUE_FOR_DELIVERY_ON_A_DAY = gql`
    query SAMPLE_ORDERS_DUE_FOR_DELIVERY_ON_A_DAY($page: Int!, $perPage: Int!, $deliveryDates: [Date]){
        sampleOrdersForDeliveryReport (page: $page, perPage: $perPage, deliveryDates: $deliveryDates) {
            page,
            pages,
            total,
            nextPage,
            previousPage,
            hasNext,
            hasPrevious,
            objects {
                invoiceId,
                publicId
                sampleOrderTaker {
                    name
                },
                status {
                    orderStatusName
                }
                availableStatusChanges{
                    publicId
                    orderStatusName
                }
                createdAt
                deliveryDate,
            }
        }
    }
`;

export const SAMPLE_ORDERS_DUE_FOR_COLLECTION_ON_A_DAY = gql`
    query SAMPLE_ORDERS_DUE_FOR_COLLECTION_ON_A_DAY($page: Int!, $perPage: Int!, $collectionDates: [Date]){
        sampleOrdersForCollectionReport (page: $page, perPage: $perPage, collectionDates: $collectionDates) {
            page,
            pages,
            total,
            nextPage,
            previousPage,
            hasNext,
            hasPrevious,
            objects {
                invoiceId,
                publicId
                sampleOrderTaker {
                    name
                },
                status {
                    orderStatusName
                }
                availableStatusChanges{
                    publicId
                    orderStatusName
                }
                createdAt
                deliveryDate,
            }
        }
    }
`;

export const USER_ACTIVITY_REPORT = gql`
    query USER_ACTIVITY_REPORT($page: Int!, $perPage: Int!, $users: [String]){
        userActivityReport (page: $page, perPage: $perPage, users: $users) {
            page,
            pages,
            total,
            nextPage,
            previousPage,
            hasNext,
            hasPrevious,
            objects {
                activityDate,
                activityMessage
            }
        }
    }
`;
